module.exports = __webpack_public_path__ + "img/5.4c8b8720.jpg";